import {SagaIterator} from 'redux-saga';
import {takeEvery, put} from 'redux-saga/effects';

import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {
    saveApplePayPayment,
    setLoadingApplePay,
} from 'desktop/pages/checkout/store/reducers/paymentStep/applePay/applePay';
import {sendPayerInfoToSaga} from 'desktop/pages/checkout/store/reducers/paymentStep/payerInfo/payerInfo';
import {ActionType} from 'types/reducers';

/**
 * Go through apple pay process
 */
export function* makeApplePayPayment({
    payload: {token},
}: ActionType<{token: string}>): SagaIterator {
    yield put(setLoadingApplePay(true));
    yield put(
        sendPayerInfoToSaga({
            method: PAYMENTS.METHOD_APPLE_PAY,
            token,
        }),
    );
}

/**
 * Root Apple Pay Saga
 */
export function* applePaySaga(): SagaIterator {
    yield takeEvery(`${saveApplePayPayment}`, makeApplePayPayment);
}
